import React from "react";
import {
	View,
	StyleSheet
} from "react-native";
import StyledButton from "ae-base/Base/StyledButton";

import Style from "ae-style";
import { useResources } from "@aetonix/hooks";

const styles = StyleSheet.create({
	panel: {
		flex: 1,
		flexDirection: "row",
		justifyContent: "space-between"
	},
	margin: {
		marginRight: Style.layout.paddingList
	}
});

export default function Navigator(props){
	const {dispatch, localize} = useResources();

	const download = dispatch("linkopener:trigger:open", {
		uri: props.url,
	});

	const close = dispatch("fileviewer:trigger:close");

	const renderBack = props.back ? (
		<StyledButton style={styles.margin} contrast onPress={close} title={localize("pdf.close")} />
	) : null;

	const renderDownload = (!props.noDownload) ? (
		<StyledButton style={styles.margin} constrast onPress={download} title={localize("pdf.download")} />
	) : null;

	return (
		<View style={styles.panel}>
			{renderBack}
			{renderDownload}
		</View>
	);
}